import React from "react";
import Card from "../Card";

function BusinessOwnersTab() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
        gap: "1.75rem",
      }}
    >
      <div style={{ fontSize: 14, color: "#475569" }}>
        <p>
          Your company and personal finances should reinforce each other — not
          compete for attention. We connect your operating company and personal
          balance sheet into one coherent picture.
        </p>
        <h4
          style={{
            margin: "0.75rem 0 0.5rem 0",
            fontSize: 15,
            fontWeight: 600,
          }}
        >
          How we help:
        </h4>
        <ul style={{ paddingLeft: "1.1rem" }}>
          <li>Liquidity event planning</li>
          <li>Cash and short-duration strategies</li>
          <li>401(k) and retirement plan guidance</li>
          <li>Key person risk and insurance coordination</li>
          <li>Entity and distribution planning with your CPA</li>
        </ul>
      </div>
      <Card
        title="Who this is for"
        body="Owners and leadership teams of New England-based businesses who want their company and personal finances working in sync."
      />
    </div>
  );
}

export default BusinessOwnersTab;
